module.exports = __webpack_public_path__ + "assets/img/culture_imgbg.f43fef6f.png";